import { Col } from 'react-bootstrap';

interface InfoRowProps {
  label: string;
  classLabel?: string;
  value: string;
  classValue?: string;
}

const InfoRow = ({ label, value, classLabel = '', classValue = '' }: InfoRowProps) => {
  return (
    <Col className='d-flex flex-fill py-1 justify-content-between'>
      <span className={classLabel}>{label}</span>
      <span className={`ps-2 ${classValue}`}>{value}</span>
    </Col>
  );
};

export default InfoRow;
